import { createSelector } from 'reselect';
import { getIsAppConfigState } from './getIsAppSelector';

const getDeepLinkPrefix = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.deepLinkPrefix ?? config?.deepLinkPrefix ?? 'mlbatbat://';
};

export const getDeepLinkConfigState = createSelector(
    [getDeepLinkPrefix, getIsAppConfigState],
    (deepLinkPrefix, isApp) => {
        return { deepLinkPrefix, isApp };
    }
);
